
// import { Utils } from '../utils/Utils'

export const Search = {
  checked_post_types: [],
  onLoad: function() {
    if ($('body.search')) {
      /*
      const url_params_array = Utils.getArrayOfURLParams('post_types%5B%5D')
      if (url_params_array) {
        if (Array.isArray(url_params_array)) {
          this.checked_post_types = url_params_array
        } else {
          this.checked_post_types.push(url_params_array)
        }
      }
      */
      this.checked_post_types = $('#search-form input[name="post_type[]"]:checkbox:checked').map(function() {
        return $(this).val()
      }).get()
      Search.onPostTypeFilterChange()
    }
  },
  onPostTypeFilterChange: function() {
    $('#post-type-dropdown input').on('change', function() {
      const $this = $(this)
      setTimeout(function() {
        const value = $this.val()
        const is_checked = $this.is(':checked')
        // console.log('is_checked', is_checked, Search.checked_post_types)
        if (is_checked) {
          if (Search.checked_post_types.indexOf('all') !== -1) {
            Search.checked_post_types = [value]
          } else {
            Search.checked_post_types.push(value)
          }
        } else {
          // uncheck
          for (let i = 0; i < Search.checked_post_types.length; i++) {
            if (Search.checked_post_types[i] === value) {
              Search.checked_post_types.splice(i, 1)
            }
          }
        }
        // if all checked OR areAllChecked func returns true
        if (Search.checked_post_types.indexOf('all') !== -1 || Search.areAllChecked()) {
          Search.checked_post_types = []
        }
        // eslint-disable-next-line no-undef
        let url = THEME.site_url + '?s=' + $('#search-form #search').val()
        if (Search.checked_post_types.length) {
          let post_type_url = ''
          Search.checked_post_types.forEach( function(postType) {
            // post_type_url += '&post_type[]=' + postType // TODO: Fix this
            post_type_url += '&post_type%5B%5D=' + postType // Temp fix
          })
          url += post_type_url
        }
        // console.log(Search.checked_post_types, url)
        location.href = url
      }, 500)
    })
  },
  areAllChecked: function() {
    // return false if not found
    if (this.checked_post_types.indexOf('post') === -1) {
      return false
    } else if (this.checked_post_types.indexOf('customer_story') === -1) {
      return false
    } else if (this.checked_post_types.indexOf('event') === -1) {
      return false
    } else if (this.checked_post_types.indexOf('page') === -1) {
      return false
    } else if (this.checked_post_types.indexOf('press') === -1) {
      return false
    } else if (this.checked_post_types.indexOf('resource_hub') === -1) {
      return false
    }
    return true  // return true if all found
  },
}



// WEBPACK FOOTER //
// ./scripts/modules/Search.js